// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMUrlUtilService } from '@app/services';

interface SearchListCriteria {
  listName?: {
    value?: string,
    filterType: string
  };
  titleName?: {
    value?: string,
    filterType: string
  }
  businessClass?: string;
  dataType?: string[];
}

@Injectable()
export class LMCreateReportSearchListDialogService {

  createReportUrl: string;
  reportType: LMReportType;

  constructor(
    private lmUrlUtilService: LMUrlUtilService,
  ) {

  }

  public getReportUrl(businessClass: string) {
    const baseUrl = this.lmUrlUtilService.getBaseUrl();
    const url = `${baseUrl}/report/${businessClass}`;
    return this.lmUrlUtilService.propagateSessionKeys(url, '?');
  }
}
